import _ from "lodash"
import moment from "moment"
import convertBoolean from "util/convertBoolean"
import exportCSV from "util/exportCSV"
import Signal from "../Signal"
import { observable, action } from "mobx"
import track from "shop/track"
import swal from "sweetalert"
import shop from "shop/shop"
import languageStore from "stores/languageStore";

const debounce = _.debounce

const TAX_RATE_BY_COUNTRY = {
  DE: 19,
  DEUTSCHLAND: 19,
  AT: 20,
  A: 20,
  ÖSTERREICH: 20,
  OESTERREICH: 20,
  CH: 8.1,
  SCHWEIZ: 8.1
}
const DEFAULT_TAX_RATE = 19

export function getTaxRateForCountry( country ) {
  return TAX_RATE_BY_COUNTRY[ String( country ).toUpperCase() ] || DEFAULT_TAX_RATE
}

export default class CartService {
  _version = 1.2
  @observable tax = 0
  @observable taxRate = DEFAULT_TAX_RATE
  @observable brutto = 0
  @observable sum = 0
  @observable sumDiscount = 0
  @observable sumDiscountReal = 0
  @observable activeCoupons = []
  @observable count = 0
  @observable size = 0
  @observable data = {
    extras: {}
  }
  @observable ready = false
  @observable productsById = new Map()
  @observable loading = false

  @observable deliveraddress = false

  constructor( { api } ) {
    this.api = api
    window.cart = this
    this.data = {
      extras: {}
    }
    this.data.products = this.data.products || {}
    this.data.deliverdate = ""
    this.data.deliveraddress = {}
    this.data.extras = this.data.extras || {}
    // this.sum              = 0
    this.size = 0
    this.hooks = {}
    this.hooks.preInsert = new Signal()
    this.hooks.afterInsert = new Signal()
    this.hooks._preChange = new Signal()
    this.hooks.changed = new Signal()
    this.hooks.loaded = new Signal()
    this.hooks.preSubmit = new Signal()

    this.hydrate()

    // persists cart into localstorage on window close/refresh
    window.addEventListener( "beforeunload", () => {
      //this.saveImmediate()
    }, false )
  }


  @action
  setDeliverAddress( address ) {
    this.setAddress( { location: address } )
    console.log( "CART: setDeliverAddress", address )
  }

  @action
  handleDeliveryAdjustmentOnLogin = async () => {
    try {
      const locations = await shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      console.log( "LOCATIONS!", locations.length, { locations } )

      if ( locations.length < 1 ) {
        console.info( "Keine Versandadressen vorhanden" )
        return
      }
      const activeDeliverAddress = locations.some( location => location.extras.haupt === "J" ? shop.cart.setAddress({ location }) : false )

      //console.log( "ACTIVE DELIVER ADDRESS", activeDeliverAddress )
      //shop.cart.setAddress( { activeDeliverAddress } )
    } catch (error) {
      console.error( "Error fetching delivery addresses:", error )
    }

    shop.cart.handleDeliverProcess()
  }

  @action
  handleDeliverProcess = async () => {
    let deliverAddress = Object.keys(shop.cart.data.deliveraddress || {}).length === 0 ? shop.session.value : shop.cart.data.deliveraddress;
    console.log("deliverAddress",deliverAddress, shop.cart.data)
    //if((deliverAddress.extras && deliverAddress.extras.lieferart == "EL" && deliverAddress && deliverAddress.extras.tour == "") || (deliverAddress.extras && deliverAddress.extras.lieferart == "") || (shop.session && shop.session.shopuser && shop.session.shopuser.guest) || (deliverAddress.extras && !deliverAddress.extras.lieferart)){
      if (!deliverAddress.extras || // wenn nichts angegeben ist
        (deliverAddress.extras.lieferart == "EL" && deliverAddress.extras.tour == "") ||  // wenn Eigenlieferung aber ohne Tourenangabe
        ((deliverAddress.extras.lieferart == "" || !deliverAddress.extras.lieferart) || (deliverAddress.extras.tour == "" || !deliverAddress.extras.tour)) || // Wenn keine Lieferart oder Tour angegeben ist
        (shop.session && shop.session.shopuser && shop.session.shopuser.guest)){
      console.log("handleTourChange", deliverAddress.pcode)
      await fetch('https://shop.hueser-vanzwoll.de/shop/rest/external/?id=touren', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          pcode: deliverAddress.pcode
        })
      })
      .then(response => response.json())
      .then(data => {
      console.log('Success TOUR:', data);
      deliverAddress.extras.tour = data.tour;
      deliverAddress.extras.lieferart = data.lieferart;
      deliverAddress.extras.umkreis60 = data.umkreis60;
      shop.cart.setExtra("umkreis60", data.umkreis60);
      shop.cart.setExtra( "deliveryEL", data.lieferart ? data.lieferart : "" )
      })
      .catch((error) => {
      console.error('Error:', error);
      });
    }
    await fetch('https://shop.hueser-vanzwoll.de/shop/rest/external/?id=liefertermin', {
      method: 'POST',
      credentials: 'include',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
      deliver: {
        name1: deliverAddress.name1,
        street: deliverAddress.street,
        pcode: deliverAddress.pcode,
        city: deliverAddress.city,
        extras: {
          tour: (deliverAddress.extras && deliverAddress.extras.tour) ||  "",
          lieferart: (deliverAddress.extras && deliverAddress.extras.lieferart) || "",
          pickUp: (shop.cart.data.extras && shop.cart.data.extras.pickUp) || "",
        }
      },
      positions: shop.cart.data.positions
      })
    })
      .then(response => response.json())
      .then(data => {
      //console.log('Success:', data);
      shop.cart.setExtra( "deliveryMessage", data.text )
      shop.cart.setExtra( "deliverdate", data.deliverdate ? data.deliverdate : "" )
      shop.cart.setExtra( "deliveryTour", data.tour ? data.tour : "" )
      })
      .catch((error) => {
      console.error('Error:', error);
      });
  }

  @action
  export = ( {
               products = this.products,
               filename = `products-${process.env.REACT_APP_ID}-${moment().format( "YYYY-MM-DD--HH-mm" )}`
             } = {} ) => {
    const headers = {
      article_nr: "Artikel Nummer",
      count     : "Anzahl",
      desc      : "Beschreibung (optional)"
    }

    const itemsFormatted = products
      .map( pos => {
        return {
          article_nr: pos.article_nr,
          count     : pos.count,
          desc      : pos.desc.des.split( "," ).join( " " )
        }
      } )

    console.log( "EXPORT FROM CART", { itemsFormatted } )
    exportCSV( headers, itemsFormatted, filename ); // call the exportCSVFile() function to process the JSON and trigger the download
  }

  @action
  hydrate() {
    //let cart = store.get( "cart" ) || {}
    if ( !this.api.session ) return false
    this.get()
    this.loadCart( {} )
    this.data.extras = this.data.extras || {}
  }

  @action
  hydrateLogin() {
    //let cart = store.get( "cart" ) || {}
    if ( !this.api.session ) return false
    this.getLogin()
    this.loadCart( {} )
    this.data.extras = this.data.extras || {}
  }

  /**
   * receive all Orderlists from wordpress
   * @returns {Promise<any | Array>}
   */
  getIndex() {
    return fetch( `${this.api.config.BASE}wp/wp-json/cart/v1/index`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8",
        "bshop-id"    : this.api.session.value.map_id
      }
    } )
      .then( res => res.json() )
      .then( result => {
        console.log( "GET INDEX", { result } )
        return result
      } )
      .catch( err => {
        console.error( "Error fetching Merklisten", err )
        return []
      } )
  }

  /**
   * Delete a orderlist from wordpress api
   * @param cartId
   * @returns {Promise<any>}
   */
  deleteOrderlist( cartId ) {
    return fetch( `${this.api.config.BASE}wp/wp-json/cart/v1/cart/${cartId}`, {
      method     : "DELETE",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8",
        "bshop-id"    : this.api.session.value.map_id
      }
    } )
      .then( res => res.json() )
      .then( cart => {
        console.log( "GET", { cartId, cart } )
        return cart
      } )
  }

  /**
   * Fetch orderlist
   * @param cartId
   * @returns {Promise<any>}
   */
  getOrderlist( cartId ) {
    return fetch( `${this.api.config.BASE}wp/wp-json/cart/v1/cart/${cartId}`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8",
        "bshop-id"    : this.api.session.value.map_id
      }
    } )
      .then( res => res.json() )
      .then( cart => {
        // console.log( "GET", { cartId, cart } )
        return cart
      } )
  }

  /**
   * Save an orderlist to wordpress
   * @param cartId
   * @param cart
   * @returns {Promise<any>}
   */
  postOrderlist( cartId, cart ) {
    const url = cartId ? `${this.api.config.BASE}wp/wp-json/cart/v1/cart/${cartId}` : `${this.api.config.BASE}wp/wp-json/cart/v1/cart/`
    return fetch( url, {
      method     : "POST",
      body       : JSON.stringify( cart ),
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8",
        "bshop-id"    : this.api.session.value.map_id
      }
    } )
      .then( res => res.json() )
      .then( cart => {
        console.log( "POST", { cartId, cart } )
        return cart
      } )
  }

  /**
   * TODO: BACKEND WIP
   * @param cartId
   * @returns {*}
   */
  getCart( cartId ) {
    return this.api.fetch( `data/orders/cart?cartid=${cartId}`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8"
      }
    } )
      .then( cart => {
        console.log( "GET", { cartId, cart } )
        return cart
      } )
  }

  /**
   * TODO: BACKEND WIP
   * @param cartId
   * @param cart
   * @returns {*}
   */
  postCart( cartId, cart ) {
    return this.api.fetch( `shop/rest/data/orders/cart?cartid=${cartId}`, {
      method     : "POST",
      body       : JSON.stringify( cart ),
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8"
      }
    } )
      .then( cart => {
        console.log( "POST", { cartId, cart } )
        return cart
      } )
  }


  @action
  reset() {
    this.data = {
      extras: {}
    }
    this.data.products = {}
    this.data.deliverdate = ""
    this.data.deliveraddress = {}
    this.data.extras = {}
    this.sum = 0
    this.count = 0
    this.size = 0
    this.ready = false
    this.productsById = new Map()
  }

  @action
  async loadCart( cart = {} ) {
    this.loading = true
    //console.log( "LOAD CART datacart", cart )
    this.data = cart
    this.data.extras = cart.extras || {}
    this.data.products = cart.positions || {}
    this.data.deliveraddress = cart.deliveraddress || {}

    // if ( !this.data.deliveraddress || !this.data.deliveraddress.mapid ) {
    //   this.data.deliveraddress = false
    // }
    // Hier läuft was falsch!
    let byId = new Map()
    
    //console.log("LOAD CART byId NEW MAP", byId, this.data.products)
    if ( this.data.giftcards ) {
      this.activeCoupons = this.data.giftcards
    }
    if ( this.data.products.map ) {
      let updates = this.data.products
        .sort( ( a, b ) => a.article_id > b.article_id ? 1 : -1 )
        .map( product => {
          let id = product.article_id || product.map_id
          return this.api.product( id )
            .then( fullProduct => {
              product.extras = product.extras || {}
              let desc = fullProduct.desc
              Object.assign( product.extras, fullProduct.extras )
              Object.assign( fullProduct, product )
              fullProduct.desc = desc
              byId.set( fullProduct.map_id, fullProduct )
            } )
        } )

      console.log("LOAD CART byId", byId)

      await Promise.all( updates )

      this.loading = false
      this.productsById = byId
      this.update()
    }
  }

  getTaxRate() {
    const country = ( this.data.deliveraddress && this.data.deliveraddress.country )
      || ( this.api.session.value && this.api.session.value.country )
    return getTaxRateForCountry( country )
  }

  getBaseAddress() {
    let base = this.api.session.value || {}
    return {
      city   : base.city,
      country: base.country,
      email  : base.email,
      fax    : base.fax,
      mapid  : base.map_id,
      name1  : base.name1,
      name2  : base.name2,
      name3  : base.name3,
      pcode  : base.pcode,
      phone  : base.phone,
      street : base.street
    }
  }

  contains( product ) {
    return this.containsId( product.map_id )
  }

  containsId( id ) {
    return this.productsById.get( String( id ) )
  }

  @action
  setExtra( item, value ) {
    this.data.extras = this.data.extras || {}
    this.data.extras[ item ] = value
    this.hooks.changed.dispatch( { cart: this } )
    //console.log("setExtra", this.data)
    this.debouncedPostMeta( { extras: this.data.extras } )
    // this.save()
  }

  @action
  setExtraPositions(product, item, value ) {
    //console.log("setExtraPositions", this.data)
    //console.log("setExtraPositions product, item, value", product, item, value)
    if(this.data && this.data.positions){
      this.data.positions.forEach(position => {
        console.log("setExtraPositions position", position.article_id, product.map_id)
        if (position.article_id == product.map_id) {
          position.extras[item] = value;
          console.log("setExtra position.extras", position)
        }
      });
    }
    this.debouncedPostMeta( { position: this.data.positions } )
    this.hooks.changed.dispatch( { cart: this } )
    //console.log("setExtraPositions", this.data)
    //console.log("setExtraPositions product", product)
    //this.data.extras = this.data.extras || {}
    //this.data.extras[ item ] = value
    //this.hooks.changed.dispatch( { cart: this } )
    //this.debouncedPostMeta( { extras: this.data.extras } )
    // this.save()
  }

  getExtra( item ) {
    // this.data.extras = this.data.extras || {}
    if ( !this.data.extras ) return {}
    return this.data.extras[ item ]
  }

  @action
  setAddress( { location } ) {
    console.log( "CART: setAddress", location )
    if ( !location ) console.error( "setAddress: {location} is undefined" )
    if ( location && location.addition ) {
      location.extras = location.extras || {}
      location.extras.addition = location.addition
      location.zusatz = location.addition
    }
    this.data.deliveraddress = location

    this.hooks.changed.dispatch( { cart: this } )
    if ( !location ) {
      // this.postMeta({deliveraddress: this.api.session.value}) // NOT WORKING
      this.postMeta( { deliveraddress: { mapid: "delete" } } )
      return
    }
    this.postMeta( { deliveraddress: this.data.deliveraddress } )
  }

  @action
  setCostCentre( { costcentre = "" } = {}) {
    this.data.costcentre = costcentre;
    console.log('post meta',this.data);
    this.debouncedPostMeta( { costcentre });
  }

  @action
  setAddressGuest( { location } ) {
    console.log( "CART: setAddressGuest", location )
    if ( !location ) console.error( "setAddress: {location} is undefined" )
    if ( location.addition ) {
      location.extras = location.extras || {}
      location.extras.addition = location.addition
      location.zusatz = location.addition
    }
    this.data.deliveraddress = location

    this.hooks.changed.dispatch( { cart: this } )
    if ( !location ) {
      // this.postMeta({deliveraddress: this.api.session.value}) // NOT WORKING
      this.postMeta( { deliveraddress: { mapid: "delete" } } )
      return
    }
    this.postMeta( { address : this.data.deliveraddress } )
    this.postMeta( { deliveraddress: this.data.deliveraddress } )
  }

  @action
  setComment( { comment = "" } = {} ) {
    this.data.comment = comment
    // dedicated debounce so a comment edit is never dropped by another cart action
    // (address/extra/deliverdate/position) sharing debouncedPostMeta within the same 350ms window
    this.debouncedPostComment( { comment } )
  }

  @action
  setDeliverdate( { deliverdate = "" } = {} ) {
    this.data.deliverdate = deliverdate
    console.info( { deliverdate } )
    this.debouncedPostMeta( { deliverdate } )
  }

  @action
  clear( extras = {} ) {
    this.productsById.clear()
    this.data = { extras }

    this.data.products = {}
    this.update()
    this.save()
  }

  map( fx ) {
    let out = []
    this.productsById.forEach( ( product, key ) => {
      // console.log("forEach", product, key)
      out.push( fx( product, key ) )
    } )
    return _.sortBy( out, "article_id" )
  }

  forEach( fx ) {
    this.productsById.forEach( fx )
  }

  @action
  updateLocally( product ) {
    this.productsById.set( product.map_id, product )
    console.log("updateLocally", product)
  }

  @action
  async update() {
    let size = 0
    let price = 0
    let count = 0

    let sumDiscount = 0
    let sumDiscountReal = 0
    //console.log("cart update", this.productsById)
    
    this.productsById.forEach( product => {
      //console.log("cart update", product)
      if ( this.api.config.checkout && this.api.config.checkout.limitToStock ) {
        let maxAvailableCount = Math.floor( product.stock / product.unit_multi )
        product.count = Math.min( maxAvailableCount, product.count )
      }
      product.count = Math.max( product.count || 0, 0 )
      
      if(product.pinfos){
        // CALCLULATE DISCOUNT FOR POSITION AND POSITION ITEM
        //console.log("pinfos",product.pinfos)
        product.discount_value = Number( product.price ) - (Number( product.pinfos.brutto ) / 100 * (100 + Number( product.extras.custom_discount )))
        product.discount_value_sum = product.discount_value * product.count * product.unit_multi
        
        // if ( product.pinfos.rabatt === undefined ) {
        //   // USE CUSTOM DISCOUNT
        //   product.discount_value = Number( product.pinfos.brutto ) - (product.pinfos.brutto / 100 * (100 + Number( product.extras.custom_discount )))
        //   product.discount_value_sum = product.discount_value * product.count * product.unit_multi
        // }

        sumDiscountReal += Number( product.discount_value_sum )
        sumDiscount += Number( product.discount_value_sum )
      }

      let product_price = product.price * product.count * product.unit_multi
      price += product_price
      count += (product.count * product.unit_multi) || 0
      size++
    } )
    if ( typeof price !== "number" ) {
      console.error( "Error calculating cart price." )
      price = 0
    }
    this.sum = price
    this.data.extras.sumDiscount = sumDiscount
    this.data.extras.lang = languageStore.currentLanguage
    this.sumDiscount = sumDiscount
    this.sumDiscountReal = sumDiscountReal

    this.size = size
    this.count = count
    this.hooks.changed.dispatch( { cart: this } )
    this.taxRate = this.getTaxRate()
    this.tax = this.sum / 100 * this.taxRate
    this.brutto = this.sum + this.tax

  }

  @action
  add( product, extras = {} ) {
    console.log("RETURN CART::ADD",product," ", extras)
    if ( !product ) {
      console.warn( "NO PRODUCT" )
      return false
    }

    if ( product.count <= 0 ) {
      return this.remove( product )
    }

    if ( !product.price && !(product.price == 0 && (!shop.config.plugins.NO_PRICE_OK)) ) { //shop.config.NO_PRICE_OK
      console.warn( "NO PRICE", product )
      return
    }

    if ( product.onChange ) {
      let ok = product.onChange( product )
      if ( !ok ) {
        console.warn( "CANT ADD BC ONCHANGE REFUSE", { product } )
        return false
      }
    }
    const inCart = this.productsById.get( product.map_id )
    !inCart && track.addProduct( { product } )
    //console.log( product.map_id, { inCart } )
    this.hooks.preInsert.dispatch( {
      product,
      cart: this
    } )
    let pid = this.getPID( product )
    if ( product._type !== "ProductModel" ) console.warn( "Adding non-ProductModel to the cart" )
    if(product.cleanUpValue){
      product.count -= 1
    }
    let { map_id, unit_id, unit_multi, count } = product
    product.extras = { ...product.extras, ...extras }
    //console.log( "RETURN adding to Cart", { pid }, map_id, unit_id, unit_multi, count)
    this.data.products[ map_id ] = {
      map_id,
      unit_id,
      unit_multi,
      count,
      pid: pid || null,
      extras: product.extras,
      pinfos: product.pinfos || {}
    }
    console.log("RETURN CART::ADD NO 3",product," ", extras)
    product.pid = pid
    this.productsById.set( map_id, product )
    this.hooks.afterInsert.dispatch( {
      product,
      cart: this
    } )

    this.hooks.changed.dispatch( { cart: this } )
    this.update()
    return this.postProduct( product )
    // this.save()
  }

  getPID( product ) {
    let pid
    const inCart = this.productsById.get( product.map_id || product.article_id )
    if ( inCart ) {
      pid = inCart.pid
    }
    return pid
  }

  @action
  remove( product, noSubmit = false) {
    let { map_id, unit_id, unit_multi, count } = product
    const pid = this.getPID( product )
    console.info( "removing from Cart", { pid }, map_id, unit_id, unit_multi, count, shop.cart, product )
    delete this.data.products[ map_id ]
    track.removeProduct( { product } )
    this.productsById.delete( map_id )
    this.hooks.changed.dispatch( { cart: this } )

    return this.deleteProduct( product )
    // this.save()
  }

  onChange() {
  }

  get hasDeliveryAddress() {
    const { deliveraddress } = this.data
    return deliveraddress && (deliveraddress.mapid || deliveraddress.map_id || deliveraddress.street)
  }

  saveImmediate() {
    console.log( "cart::saving" )
    let p = this.post( { extras: this.data.extras } )
    if ( !p ) return

    p.then( res => {
      try {
        localStorage.setItem( "STATE_HASH", Math.random() )
      } catch (err) {
        // NOTHING
      }
      return res
    } )
      .catch( err => {
        this.api.toast( err, "error" )
      } )
  }

  // SORT = article_nr, created
  @action
  get( { sort = "article_nr" } = {} ) {

    if ( !this.api.session || !this.api.session.canUseCartApi ) {
      return false
    }

    if ( !this.api.session.value ) {
      return false
    }


    return this.api.fetch( `/shop/rest/data/orders/cart?sort=${sort}&r=${Math.random()}`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
      .then( async cart => {
        cart = convertBoolean( cart )
        //console.log( "CART PRE", cart )
        cart.positions.forEach( ( pos, index ) => {
          pos._cartPos = index
        } )
        cart.deliveraddress && this.setDeliverAddress( cart.deliveraddress )
        //console.log( "CART POST", cart )
        await this.loadCart( cart )
        this.update()
        this.ready = true
        this.loading = false
        return cart
      } )
      .catch( err => console.error( err ) )
  }

  @action
  getIDbyArticleNr( article_nr, count = 1 ) {
    if ( !this.api.session || !this.api.session.canUseCartApi ) {
      return false
    }

    if ( !this.api.session.value ) {
      return false
    }
    return this.api.fetch( `/shop/rest/data/v2/search?value=${article_nr}&filter=%5B%5D&start=0&count=24&sort=des&dir=desc&artnr=0&mainonly=0&variants=0&lang=de`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
      .then( async result => {
        console.log( "getIDbyArticleNr RESULT", [result.result[0].map_id, article_nr, count] )
        return { map_id: result.result[0].map_id, article_nr, count }
      } )
      .catch( err => console.error( err ) )
  }

  @action
  getLogin( { sort = "article_nr" } = {} ) {

    if ( !this.api.session || !this.api.session.canUseCartApi ) {
      return false
    }

    if ( !this.api.session.value ) {
      return false
    }


    return this.api.fetch( `/shop/rest/data/orders/cart?sort=${sort}&r=${Math.random()}`, {
      method     : "GET",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
      .then( async cart => {
        cart = convertBoolean( cart )
        console.log( "CART PRE", cart )
        cart.positions.forEach( ( pos, index ) => {
          pos._cartPos = index
        } )
        cart.deliveraddress && cart.deliveraddress.extras && cart.deliveraddress.extras.haupt && cart.deliveraddress.extras.haupt === "N" && this.handleDeliveryAdjustmentOnLogin()
        cart.deliveraddress && cart.deliveraddress.extras && !cart.deliveraddress.extras.haupt && this.setDeliverAddress( cart.deliveraddress )
        console.log( "CART POST", cart )
        await this.loadCart( cart )
        this.update()
        this.ready = true
        this.loading = false
        return cart
      } )
      .catch( err => console.error( err ) )
  }

  @action
  async postCoupons( code ) {
    try {
      let response;
      console.log("code::",code)
      if(code == "deleteCoupon"){
        console.log("DELETE")
        response = await this.postMeta( { "giftcards": [] } )
        console.log("COUPON",response)
        
        if ( response ) {
          this.activeCoupons = response.giftcards
          console.log("COUPON",response)
          //await new Promise(resolve => setTimeout(resolve, 100000));
          await this.loadCart()
          swal( "",translate( "Code entfernt" ), "success" )
          return true
        }
        else {
          console.log( "NO COUPON" )
          swal( "",translate( "Code konnte nicht entfernt werden" ), "warning" )
          return false
        }
      }
      else if(code){
        response = await this.postMeta( { "giftcards": [`${code}`] } )
        if ( response ) {
          this.activeCoupons = response.giftcards
          console.log("COUPON",response)
          await this.loadCart()
          await shop.cart.setExtra( "couponCode", code )
          console.log("COUPON",response)
          swal( code, translate( "Code aktiviert" ), "success" )
          return true
        }
        else {
          console.log( "NO COUPON", response )
          swal( code, translate( "Ungültiger Code" ), "warning" )
          return false
        }
      }
    } catch (err) {
      console.log( "postCoupons error", err )
      swal( code, err.message || translate( "Ungültiger Code" ), "warning" )
      return false
    }
  }


  @action
  postMeta( data ) {
    console.log("postMeta data",data)
    return this.api.fetch( `/shop/rest/data/orders/cart?r=${Math.random()}`, {
      body       : JSON.stringify( data ),
      method     : "POST",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
      .then( res => {
        console.log("postMeta response", res)
        this.loading = false
        // update some meta data for ui state
        this.data.costid = res.costid
        // only sync comment back from the server if THIS request actually posted a comment change,
        // otherwise an unrelated postMeta call (address/extra/deliverdate/position) resolving after a
        // pending comment edit would reset the local comment to the server's (stale/empty) value
        if ( Object.prototype.hasOwnProperty.call( data, "comment" ) ) {
          this.data.comment = res.comment || ''
        }
        return res
      } )
      .catch( e => {
        console.log( "postMeta error", e )
        this.loading = false
        return Promise.reject( e )
      } )
  }

  @action
  post( { extras, lindtService } = {} ) {
    var positions = []
    this.loading = true

    if ( !this.api.session || !this.api.session.canUseCartApi ) {
      return Promise.resolve()
    }
    this.productsById.forEach( ( product ) => {
      var serverArticle = {
        extras: product.extras
      }
      
      serverArticle.count = parseInt( product.count ) || 0
      serverArticle.unit_id = product.unit_id || console.error( "serverArticle.unit_id invalid" )
      serverArticle.article_id = product.map_id || product.article_id || console.error( "serverArticle.article_id invalid" )
      serverArticle.unit_multi = product.unit_multi || console.error( "serverArticle.unit_multi invalid" )
      serverArticle.pid = this.getPID( product )
      serverArticle.extras.discount_value_sum = product.discount_value_sum
      serverArticle.extras.custom_discount = product.extras.custom_discount
      console.log("Posting product:", product, "Server article:", serverArticle)
      // SET CUSTOM_DISCOUNT TO DEFAULT RABATT WHEN NO CUSTOM_DISCOUNT IS PRESENT
      if ( product.extras.rabatt !== undefined && product.extras.custom_discount === undefined ) {
        serverArticle.extras.custom_discount = product.extras.rabatt
      }

      if ( product.extras._custom_discount !== undefined ) {
        serverArticle.extras.rabatt = product.extras._custom_discount * -1
        serverArticle.extras.custom_discount = product.extras._custom_discount * -1
        serverArticle.rabatt = product.extras._custom_discount * -1
      } else {
        serverArticle.extras.rabatt = product.extras.rabatt
      }
      if(lindtService){
        serverArticle.count =- 1
      }
      if ( serverArticle.count !== 0 ) {
        positions.push( serverArticle )
      }
    } )

    var serverCartObject = {}

    if ( this.data.deliverdate !== false ) {
      serverCartObject.deliverdate = this.data.deliverdate
    }

    if ( this.data.deliveraddress ) {
      serverCartObject.deliveraddress = this.data.deliveraddress

      //if ( !serverCartObject.deliveraddress ) serverCartObject.deliveraddress = this.api.session.value.map_deliver_id
    } else {
      if ( this.api.session ) {
        serverCartObject.deliveraddress = { mapid: this.api.session.value.map_deliver_id }
      }
    }

    // remove invalid address
    if ( !serverCartObject.deliveraddress || !serverCartObject.deliveraddress.street ) {
      delete serverCartObject.deliveraddress
    }

    if ( positions ) {
      serverCartObject.positions = positions
    }

    if ( this.data.comment ) {
      serverCartObject.comment = this.data.comment
    }

    if ( this.data.costcentre ) {
      serverCartObject.costcentre = this.data.costcentre
    }

    serverCartObject.extras = {
      ...this.data.extras,
      ...extras
    }

    if ( shop.session.contact ) {
      serverCartObject.extras.name1 = serverCartObject.extras.name1 || shop.session.contact.name1
      serverCartObject.extras.email = serverCartObject.extras.email || shop.session.contact.email
    }


    var serverCartString = JSON.stringify( serverCartObject )
    return this.api.fetch( `/shop/rest/data/orders/cart?r=${Math.random()}`, {
      body       : serverCartString,
      method     : "POST",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
      .then( res => {
        this.loading = false
        return res
      } )
      .catch( e => {
        this.loading = false
        //swal( "Fehler", "Ihr Warenkorb konnte nicht gespeichert werden.", "error" )
      } )
  }

  deleteProduct( product ) {
    console.info( "Product not in cart", product )
    this.loading = true

    const { count, map_id, unit_id, unit_multi } = product
    const body = { positions: [{ count, unit_id, unit_multi, article_id: map_id }] }
    console.log( "DELETE CART", { body, product_map_id: product.map_id, product_pid: product.pid } )
    return this.api.fetch( `/shop/rest/data/orders/cart/products?id=${product.map_id}&$pid=${product.pid}&sort=article_nr`, {
      // body:        JSON.stringify( body ),
      method     : "DELETE",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8"
      }
    } )
      .catch( e => {
        this.loading = false
        // swal( "Fehler", e, "error" )
      } )
      .then( cart => {
        console.log( "DELETE", { cart } )
        // TODO: DOESNT WORK
        // this.debouncedLoadCart( cart )
        this.loading = false
        return this.get()
      } )
  }

  postProduct( product ) {
    const { count, map_id, unit_id, unit_multi } = product
    if ( product.count <= 0 ) return
    this._lastUpdatePositions = this._lastUpdatePositions || []
    this._lastUpdatePositionById = this._lastUpdatePositionById || {}
    const serverArticle = { count, unit_id, unit_multi, article_id: map_id }
    serverArticle.pid = this.getPID( product )
    serverArticle.extras = product.extras
    serverArticle.pinfos = product.pinfos || {}
    serverArticle.extras.discount_value_sum = product.discount_value_sum
    console.log("RETURN CART::POST PRODUCT", product, " ", serverArticle)
    if(serverArticle.extras.customPrice){
      serverArticle.extras.customPrice = product.extras.customPrice
      serverArticle.params = { customPrice: product.extras.customPrice }
    }
    if(product.pinfos && product.pinfos.brutto){
      serverArticle.extras.couponPrice = product.pinfos.brutto

    }
    if(product.pinfos && !product.pinfos.brutto){
      serverArticle.extras.baseCustomerPrice = product.price
    }
    if(product.extras.veCount && product.extras.veCount.value && product.extras.veCount.value.value){
      serverArticle.extras.veCount_success = product.extras.veCount.value.value
    }
    
    if ( product.extras._custom_discount !== undefined ) {
      // NEW CUSTOM RABATT
      serverArticle.extras.rabatt = product.extras._custom_discount * -1
      serverArticle.extras.custom_discount = product.extras._custom_discount * -1
    } else {
      serverArticle.extras.custom_discount = product.extras.custom_discount || product.extras.rabatt
    }
    this._lastUpdatePositionById[ serverArticle.article_id ] = serverArticle
    this._lastUpdatePositions.push( serverArticle )
    return this.prepareUpdate()
  }

  postUpdate = () => {
    this.loading = true
    this._lastUpdatePositions = Object.values( this._lastUpdatePositionById )
    const body = { positions: this._lastUpdatePositions }
    //console.log( "POST CART", { positions: body.positions } )
    this._lastUpdatePositions = []
    this._lastUpdatePositionById = {}
    return this.api.fetch( `/shop/rest/data/orders/cart/products?sort=article_nr`, {
      body       : JSON.stringify( body ),
      method     : "POST",
      credentials: "include",
      headers    : {
        "Content-Type": "application/json; charset=utf-8"
      }
    } )
      .catch( e => {
        this.loading = false
        swal( "Fehler", e, "error" )
      } )
      .then( cart => {
        //console.log( "RECEIVED", { cart } )
        this.debouncedLoadCart( cart )
        this.loading = false
        try {
          localStorage.setItem( "STATE_HASH", Math.random() )
        } catch (err) {
          // NOTHING
        }
        return cart
      } )
  }

  prepareUpdate = _.debounce( this.postUpdate, 800, { leading: false, trailing: true } )
  debouncedPostMeta = _.debounce( this.postMeta, 350, { leading: false, trailing: true } )
  debouncedPostComment = _.debounce( this.postMeta, 350, { leading: false, trailing: true } )

  get products() {
    return [...this.productsById.entries()].map( a => a[ 1 ] )
  }

  @action
  submit( { extras, lindtService } = {} ) {
    //TODO: TRENDIMPORT SUBMIT FIX/LOG
    // window.TrackJS && window.TrackJS.console.log( {
    // 	type: "event",
    // 	data: {action: "SUBMIT", products: this.products }
    // } );
    // console.error("CART SUBMIT", this.products)
    extras.locale = languageStore.locale
    return this.post( { extras, lindtService } )
      .then( () => {
        return this._submit( { extras } )
          .then( ( bill ) => {
            console.log( `bill`, bill )
            track.purchase( { order: bill, products: this.products } )
            this.loadCart( {} )
            return bill
          } )
      } )
      .then( order => {
          order.deliver = order.deliver || {}
          return order
        }
      )
  }

  _submit( { extras } ) {
    let body = {
      extras,
      acceptagb: true,
      sum      : Math.round( this.sum * 100 )
    }
    return this.api.fetch( "/shop/rest/data/orders/cart/submit", {
      body       : JSON.stringify( body ),
      method     : "POST",
      credentials: "include",
      headers    : {
        "content-type": "application/json; charset=utf-8"
      }
    } )
  }

  debouncedLoadCart = debounce( this.loadCart, 1000, {
    leading : true,
    trailing: true
  } )

  save = _.throttle( this.saveImmediate, 320, {
    leading : true,
    trailing: true
  } )

}



// WEBPACK FOOTER //
// ./src/sdk/cart/Cart.js